import axios from 'axios'

import config from '../../config'

const createAuthRole = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/AuthRoles`
  return axios.post(url, data)
}

export default createAuthRole
